import React from 'react';
import EditableTable from 'src/views/admin/EditableTable';
import {Field} from 'formik';
import PhotoUpload from 'shared/components/form-inputs/time-sensitive-items/photo-upload';
import styles from './styles.module.scss';

const ThumbnailField = (): React.ReactElement => (
  <Field name="thumbnail">
    {({field: {value, name}, form: {setFieldValue}}): React.ReactElement => (
      <PhotoUpload value={value} onChange={(newValue): void => setFieldValue(name, newValue)} />
    )}
  </Field>
);

const columns = [
  {
    name: 'title',
    title: 'Title',
  },
  {
    name: 'link',
    title: 'Link',
    renderValue: function linkDisplay(value): React.ReactElement {
      return (
        <a href={value} target="_blank" title={value} rel="noopener noreferrer">
          {value.length > 20 ? `${value.substring(0, 20)}...` : value}
        </a>
      );
    },
  },
  {
    name: 'thumbnail',
    title: 'Thumbnail',
    renderValue: function thumbnailDisplay(value): React.ReactElement {
      return <img src={value} className={styles.thumbnailPreview} />;
    },
    FormField: ThumbnailField,
  },
  {
    name: 'description',
    title: 'Description',
    type: 'textarea',
    width: '50%',
  },
  {
    name: 'priority',
    title: 'Priority',
    type: 'number',
    renderValue: (value): number => (value ? value : 0),
  },
];

const EditResourcesForCategory = (props: {
  category: string;
  userTypes?: string[];
}): React.ReactElement => {
  const userTypesQuery = props.userTypes?.length ? `&userTypes=${props.userTypes.join(',')}` : '';

  return (
    <EditableTable
      basePath={`/v1/resources?resourceCategory=${props.category}${userTypesQuery}`}
      defaultSortKey="order"
      columns={columns}
      identifier={props.category}
    />
  );
};

export default EditResourcesForCategory;
